import {
	createStyles,
	makeStyles
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth,
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		providerEndorsement_container: {
			height: '100%',
			display: 'flex',
			flexDirection: 'column',
		},
		providerEndorsement_headerContainer: {
			background: theme.palette.primary.main,
		},
		providerEndorsement_header: {
			width: '100%',
			margin: '0 auto',
			maxWidth: '1080px',
			display: 'flex',
			justifyContent: 'space-between',
			height: '100%',
		},
		providerEndorsement_backButtonContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			padding: theme.spacing(1, 0),
		},
		providerEndorsement_backButton: {
			padding: theme.spacing(0),
			color: theme.palette.common.white,
		},
		providerEndorsement_backButtonIcon: {
			fontSize: theme.spacing(6),
		},
		providerEndorsement_endorsementCostContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		providerEndorsement_endorsementCostTitle: {
			color: theme.palette.common.white,
			fontSize: theme.typography.subtitle1.fontSize,
			display: 'flex',
			justifyContent: 'center',
			marginBottom: theme.spacing(.5),
		},
		providerEndorsement_endorsementCostAmount: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'left',
			color: theme.palette.common.white,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.h5.fontSize,
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.h6.fontSize,
			},
		},
		providerEndorsement_endorsementCostAmountWithLetterSpacing: {
			letterSpacing: theme.spacing(.25),
		},
		providerEndorsement_headerIconButtonContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		providerEndorsement_headerIconButton: {
			borderRadius: 0,
		},
		providerEndorsement_headerIconButtonIcon: {
			color: theme.palette.common.white,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.spacing(4),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.spacing(3.5),
			},
		},
		providerEndorsement_headerIconButtonOpen: {
			background: theme.palette.background.default,
		},
		providerEndorsement_headerIconButtonIconOpen: {
			color: `${theme.palette.primary.main} !important`,
		},
		providerEndorsement_actionButtonContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		providerEndorsement_actionButton: {
			color: theme.palette.common.white,
			border: `1px solid ${theme.palette.common.white}`,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				height: theme.spacing(5),
				minWidth: theme.spacing(16),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				height: theme.spacing(4),
				minWidth: theme.spacing(14),
			},
		},
		providerEndorsement_leftHeader: {
			display: 'flex',
			paddingLeft: theme.spacing(3),
			'& > div': {
				[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
					padding: theme.spacing(1, 2, 1, 0)
				},
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					padding: theme.spacing(1, 1, 1, 0)
				},
			}
		},
		providerEndorsement_rightHeader: {
			display: 'flex',
			paddingRight: theme.spacing(3),
			'& > div': {
				[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
					padding: theme.spacing(1, 0, 1, 2)
				},
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					padding: theme.spacing(1, 0, 1, 1)
				},
			},
		},
		providerEndorsement_rightHeaderIconButtonContainer: {
			display: 'flex',
		},
		providerEndorsement_content: {
			height: 0,
			flex: '1 0 auto',
		},
		providerEndorsement_moreOptionItem: {
			paddingTop: theme.spacing(1.5),
			paddingBottom: theme.spacing(1.5),
		},
	});
});

export default useStyles;